/* NATHRA cart upsell: one-tap add for the "2nd pair 20% off" offer.
   Adds the variant, then fires the theme's cart:update event so the cart drawer re-renders. */
(function () {
  if (window.__nathraUpsell) return;
  window.__nathraUpsell = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nathra-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var id = Number(btn.getAttribute('data-nathra-upsell-add'));
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.getAttribute('data-adding') || 'Adding';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: cart,
          sourceId: 'nathra-upsell',
          data: { source: 'nathra-upsell', itemCount: cart.item_count, variantId: String(id) }
        };
        document.dispatchEvent(ev);
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('nathra_upsell_add', { variantId: id });
          }
        } catch (err) {}
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      });
  });
})();
